import React from "react"
import { UserList } from "../component/user/UserList"
import { NavLink } from "react-router-dom"
import { Button } from "react-bootstrap"
import { useLiveSpaces } from "popopo-lib-front/firestore-access"
import { firestore } from "../core"
import { Paths } from "../paths"

export const Top = () => {
  const spacesLive = useLiveSpaces(firestore, 100)

  return (
    <div className="row gy-5">
      <div className="col-12 d-flex flex-column align-items-center gap-3">
        <div className="d-flex gap-3">
          <NavLink to={Paths.my.path}>
            <Button variant="primary" className="btn-lg">
              My Page
            </Button>
          </NavLink>
          <NavLink to={Paths.notifications.path}>
            <Button variant="info" className="btn-lg">
              <i className="fas fa-bullhorn me-2"></i>
              お知らせ
            </Button>
          </NavLink>
          <NavLink to={Paths.shop.path}>
            <Button variant="secondary" className="btn-lg">
              <i className="fas fa-shop me-2"></i>
              ショップ
            </Button>
          </NavLink>
                  <NavLink to={Paths.stories.path}>
                    <Button variant="warning" className="btn-lg">
                      <i className="fas fa-book me-2"></i>
                      ストーリーズ
                    </Button>
                  </NavLink>
                  <NavLink to={Paths.voices.path}>
                    <Button variant="success" className="btn-lg">
                      <i className="fas fa-microphone me-2"></i>
                      ボイス
                    </Button>
                  </NavLink>
                  <NavLink to={Paths.violationReport.path}>
                    <Button variant="danger" className="btn-lg">
                      <i className="fas fa-flag me-2"></i>
                      通報
                    </Button>
                  </NavLink>
                  <NavLink to={Paths.debug.dotMoney.path}>
                    <Button variant="outline-primary" className="btn-lg">
                      <i className="fas fa-exchange-alt me-2"></i>
                      ドットマネー
                    </Button>
                  </NavLink>
                </div>
      </div>

      <div className="col-12 col-lg-6 d-flex flex-column align-items-center gap-3">
        <h3>Users</h3>
        <UserList />
      </div>

      <div className="col-12 col-lg-6 d-flex flex-column align-items-center gap-3">
        <h4>Live spaces</h4>
        <div>
          <ul className="list-group w-100">
            {spacesLive === "loading" ? (
              <li>
                <i className="fas fa-spin fa-spinner" />
              </li>
            ) : spacesLive.length === 0 ? (
              <li>ライブ中のスペースは1つも存在しません。</li>
            ) : (
              spacesLive.map((space) => (
                <li key={space.id} className="list-group-item">
                  <NavLink to={Paths.spaces.space.getPath(space.id)}>ID: {space.id}</NavLink>
                </li>
              ))
            )}
          </ul>
        </div>
      </div>
    </div>
  )
}
